import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";
import { UnitLabel } from "./UnitLabel";
import { unitOf } from "./pricingUnits";

export const AwsTierRow = ({ tier, index, onChange, currency = "USD" }) => {
  const { t } = useTranslation();
  return (
    <li className="grid gap-3 rounded-2xl border border-border/60 p-3 shadow-neu-in sm:grid-cols-2">
      <div>
        <UnitLabel text={t("tokens.upTo")} unit={unitOf("image_month", currency, t)} />
        <NeuInput data-testid={`aws-tier-limit-${index}`} type="number" placeholder="∞"
                  value={tier.up_to_images ?? ""}
                  onChange={(e) => onChange(index, "up_to_images", e.target.value)} />
      </div>
      <div>
        <UnitLabel text={t("tokens.costPerImage")} unit={unitOf("per_image", currency, t)} />
        <NeuInput data-testid={`aws-tier-cost-${index}`} type="number" step="any"
                  value={tier.cost_per_image}
                  onChange={(e) => onChange(index, "cost_per_image", e.target.value)} />
      </div>
    </li>
  );
};
